import { consumerCarleadCreatePayloadMapper } from '@wkda/carlead-creation-form';
import { useCreateCarleadForm } from './useCreateCarleadForm';
export function useCreateNormalCarleadForm(params) {
  const defaults = {
    payloadMapper: consumerCarleadCreatePayloadMapper
  };
  const carleadForm = useCreateCarleadForm([defaults, ...params]);
  return carleadForm;
}